// Общие модули сайта

import initForms from './Forms/index';
import initLazyImage from './LazyImage/index';
import initLightbox from './Lightbox/index';
import initMainMenu from './MainMenu/index';

/**
 * Общие модули сайта
 */
function main(): void
{
	initMainMenu();
	initForms();
	initLazyImage();
	initLightbox();
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/index.ts